console.log('[Gift Packaging] Script loaded at:', new Date().toISOString());

const GIFT_PACKAGING_VARIANT_ID = 42961087856737; // VERIFY THIS ID!

// Run immediately, don't wait
(function() {
  let initialized = false;
  
  function initialize() {
    if (initialized) {
      console.log('[Gift Packaging] Already initialized, skipping');
      return;
    }
    
    console.log('[Gift Packaging] Starting initialization...');
    
    const checkbox = document.getElementById('gift-packaging');
    const noteWrapper = document.getElementById('gift-note-wrapper');
    const noteTextarea = document.getElementById('gift-note');
    const counter = document.getElementById('gift-note-counter');
    
    console.log('[Gift Packaging] Elements found:', {
      checkbox: !!checkbox,
      noteWrapper: !!noteWrapper,
      noteTextarea: !!noteTextarea,
      counter: !!counter
    });
    
    if (!checkbox) {
      console.error('[Gift Packaging] CRITICAL: Checkbox not found!');
      setTimeout(initialize, 500); // Try again
      return;
    }
    
    initialized = true;
    console.log('[Gift Packaging] ✓ Checkbox found, proceeding...');
    
    // Toggle note visibility
    checkbox.addEventListener('change', function() {
      console.log('[Gift Packaging] Checkbox changed to:', this.checked);
      if (noteWrapper) {
        noteWrapper.style.display = this.checked ? 'block' : 'none';
      }
    });
    
    // Character counter
    if (noteTextarea && counter) {
      noteTextarea.addEventListener('input', function() {
        counter.textContent = this.value.length + '/500';
      });
    }
    
    // Use document-level event delegation to catch ALL form submissions
    document.addEventListener('submit', async function(e) {
      console.log('[Gift Packaging] SUBMIT EVENT DETECTED');
      console.log('[Gift Packaging] Event target:', e.target);
      console.log('[Gift Packaging] Event target tag:', e.target.tagName);
      
      // Check if this is a cart add form
      const form = e.target;
      if (!form || form.tagName !== 'FORM') {
        console.log('[Gift Packaging] Not a form, ignoring');
        return;
      }
      
      const action = form.getAttribute('action') || form.action;
      console.log('[Gift Packaging] Form action:', action);
      
      if (!action || !action.includes('/cart/add')) {
        console.log('[Gift Packaging] Not a cart add form, ignoring');
        return;
      }
      
      console.log('[Gift Packaging] ✓ This is a cart add form!');
      console.log('[Gift Packaging] Checkbox checked:', checkbox.checked);
      
      if (!checkbox.checked) {
        console.log('[Gift Packaging] Checkbox not checked, allowing normal submission');
        return;
      }
      
      // STOP EVERYTHING
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      console.log('[Gift Packaging] ========================================');
      console.log('[Gift Packaging] INTERCEPTED! Adding gift packaging...');
      console.log('[Gift Packaging] ========================================');
      
      // Get form data
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1');
      
      console.log('[Gift Packaging] Variant ID:', variantId);
      console.log('[Gift Packaging] Quantity:', quantity);
      
      if (!variantId) {
        console.error('[Gift Packaging] ERROR: No variant ID found!');
        alert('Error: Product variant ID not found');
        return;
      }
      
      // Collect all form data for debugging
      console.log('[Gift Packaging] All form data:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      // Build properties
      const properties = {
        'Gift Packaging': 'Yes - White branded box with crinkle paper (+$5)'
      };
      
      const giftNote = noteTextarea?.value?.trim();
      if (giftNote) {
        properties['Gift Note'] = giftNote;
        console.log('[Gift Packaging] Including gift note (length: ' + giftNote.length + ')');
      }
      
      // Create items array
      const items = [
        {
          id: parseInt(variantId),
          quantity: quantity,
          properties: properties
        },
        {
          id: GIFT_PACKAGING_VARIANT_ID,
          quantity: quantity,
          properties: {
            '_hidden': 'true',
            '_for_product': variantId
          }
        }
      ];
      
      console.log('[Gift Packaging] Payload:', JSON.stringify(items, null, 2));
      
      // Find submit button and disable it
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalBtnText = submitBtn?.innerHTML;
      
      if (submitBtn) {
        submitBtn.disabled = true;
        const textSpan = submitBtn.querySelector('[data-add-to-cart-text]');
        if (textSpan) {
          textSpan.textContent = 'Adding...';
        }
      }
      
      try {
        console.log('[Gift Packaging] Sending request to /cart/add.js...');
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        
        console.log('[Gift Packaging] Response status:', response.status);
        console.log('[Gift Packaging] Response headers:', [...response.headers.entries()]);
        
        const data = await response.json();
        console.log('[Gift Packaging] Response body:', data);
        
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unknown error');
        }
        
        console.log('[Gift Packaging] ✓✓✓ SUCCESS ✓✓✓');
        
        // Get current cart state
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        console.log('[Gift Packaging] Current cart:', cart);
        console.log('[Gift Packaging] Cart has', cart.item_count, 'items');
        
        // Trigger theme's cart update
        if (window.theme && window.theme.cart) {
          console.log('[Gift Packaging] Triggering theme cart update');
          if (typeof window.theme.cart.getCart === 'function') {
            window.theme.cart.getCart();
          }
        }
        
        // Dispatch events
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('product:added'));
        
        // Try to open cart drawer
        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer');
          const drawerElement = document.querySelector('[data-cart-drawer]');
          
          if (drawer && typeof drawer.open === 'function') {
            console.log('[Gift Packaging] Opening cart drawer (method 1)');
            drawer.open();
          } else if (drawerElement) {
            console.log('[Gift Packaging] Opening cart drawer (method 2)');
            drawerElement.classList.add('is-open');
          } else {
            console.log('[Gift Packaging] No drawer found, redirecting to cart page');
            window.location.href = '/cart';
          }
        }, 500);
        
      } catch (error) {
        console.error('[Gift Packaging] ❌ FAILED:', error);
        console.error('[Gift Packaging] Error stack:', error.stack);
        
        alert('Failed to add gift packaging:\n' + error.message + '\n\nPlease check the console for details.');
        
        // Restore button
        if (submitBtn && originalBtnText) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalBtnText;
        }
      }
      
    }, true); // Use capture phase!
    
    console.log('[Gift Packaging] ✓✓✓ INITIALIZATION COMPLETE ✓✓✓');
    console.log('[Gift Packaging] Listening for form submissions...');
  }
  
  // Try multiple times to ensure we catch it
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Also try after a delay in case elements load later
  setTimeout(initialize, 100);
  setTimeout(initialize, 500);
  
})();





